<template>
  <el-container class="patient-page"
                v-loading="relationShipListLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.5)">
    <el-header>
      <!-- <Header ref="header"></Header> -->
    </el-header>
    <el-main>
      <div class="patient-page-container">
        <!--左侧信息展示-->
        <div class="patient-page-left">
          <div class="tool-bar">
            <el-button @click="goBack()" type="primary" size="mini">返回</el-button>
            <div>
              <span v-if="showComponent">今日已随访: {{ followupNum }}人</span>
              <span style="margin-left: 10px;">今日指标：{{ targetData }}</span>
            </div>
          </div>
          <UserCard ref="userCard" v-if="patientData.patientId && showComponent"
                    :patientData="patientData" @getPatientTags="getPatientTags"></UserCard>
          <div style="width: 400px;margin-top: 10px;">
            <el-tabs v-model="activeName" type="border-card">
              <el-tab-pane name="1" label="参考信息">
                <referenceInformation ref="referenceInfo" v-if="patientData.patientId&& showComponent"
                                      :patientData="patientData"></referenceInformation>
              </el-tab-pane>
              <el-tab-pane name="2" label="历史随访">
                <followupHistoryList ref="followHistory" v-if="patientData.patientId&& showComponent"
                                     :patientData="patientData"></followupHistoryList>
              </el-tab-pane>
              <el-tab-pane name="3" label="医院信息">
                <PatientInHospital :patientData="patientData" ref="patientRecord"></PatientInHospital>
              </el-tab-pane>
              <el-tab-pane name="4" label="质控">
                <div v-if="checklist.length">
                  <div class="checklist-container" style="margin-bottom: 15px;" v-for="(item,index) in checklist"
                       :key="index">
                    <!-- <div style="font-weight: 700;margin-bottom: 6px;display: inline-block" >抽查时间：{{item.createTime}}</div>
                    <div style="margin-bottom: 8px;line-height: 24px;" v-html="item.sbResult"></div> -->
                    <div class="checklist-item-header">
                      <span style="font-weight: bold;">{{
                          item.secondSpotCheckState == "0" ? '不合格' : '合格'
                        }} | {{ item.handleResultName }}</span>
                      <span class="item-header-date">{{ item.createTime }}</span>
                    </div>
                    详情描述：
                    <div class="checklist-item-detail">
                      <div style="border-bottom:1px solid #ccc;">{{ item.firstSpotCheckStateStr }}</div>
                      <div class="remarks-detail" v-html="item.spotCheckRemarks" style="padding:5px"></div>
                    </div>
                    <!-- 图片展示 -->
                    <div v-if="picLoading" class="picture-show">
                      <viewer :images="item.imageUrlAfter" class="image-view">
                        <img v-for="(item,index) in item.imageUrlAfter" :key="index" :src="item" alt>
                      </viewer>
                    </div>
                    <div><span
                        style="font-weight:bold;">质控得分：{{ item.qualityScore ? item.qualityScore : '无' }}</span>
                    </div>

                    <div v-if="item.manageCheckRemarks">
                      <div class="checklist-item-header"><span style="font-weight: bold;">追加质控：</span><span
                          class="item-header-date">{{ item.replyTime }}</span></div>
                      <!--                      {{ item.manageCheckRemarks }}-->
                      <div v-for="(it,ind) in item.manageHistoryCheckRemark" :key="ind">
                        <span>{{ it.value }} </span>
                        <span>{{ it.key }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-else>
                  <span class="no-data">
                      <p>暂无质控记录</p>
                      <img src="../referenceInformation/img/no-result.png" alt="暂无数据"/>
                  </span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!--问卷部分-->
        <div class="patient-page-right " :class="{'stretchall':stretchall}">
          <div class="qs-header">
            <span class="qs-header-label">问卷信息</span>
            <div>
              <el-button @click="saveCurrentPage" type="primary" size="mini">保存当前页</el-button>
              <span v-if="patientData.lastFollowupTime">上次随访时间：</span>
              {{ patientData.lastFollowupTime }}
              <!--<el-switch-->
              <!--v-model="qsSwich"-->
              <!--active-color="#248cfa"-->
              <!--inactive-color="#606266"-->
              <!--active-text="全部展示">-->
              <!--</el-switch>-->
            </div>
            <!--<el-button type="text" icon="el-icon-s-unfold" class="stretch" @click="stretchall=true"-->
            <!--v-if="!stretchall"></el-button>-->
            <!--<el-button type="text" icon="el-icon-s-fold" class="stretch" @click="stretchall=false"-->
            <!--v-if="stretchall"></el-button>-->
          </div>
          <div class="qs-content">
            <question-new v-if="showComponent && patientData.isNewTask" :infoId="patientData.followUpPatientInfoId"
                          :admitNo="patientData.admitNo"
                          :taskId="getTaskCenterId"></question-new>
            <question-tree-node :infoId="patientData.followUpPatientInfoId" :questionDisabled="$route.query.aliLogin"
                                v-if="patientData.followupPatientId && qsLoaded && !patientData.isNewTask"
                                :patientId="followupPatientId_p" :taskId="getTaskCenterId"
                                ref="questionTreeNode" :isRecord="isRecord"></question-tree-node>
          </div>
        </div>
        <!--中间信息展示-->
        <div class="patient-page-center" v-show="!stretchall">
          <!--          <div class="patient-page-center-mask">-->

          <!--          </div>-->
          <div>
            <UserPhone refs="userphone" @afterStatus="userPhoneAfterStatus"
                       @refreshConcatInfo="asyncGetPatientContacks"
                       :patientData="patientData" ref="userphone"
                       @getPatientData="getPatientData"
                       @saveRemark="saveRemark" @getOverFollowUp="getOverFollowUp"
                       @manualCall="manualCall" @getCallSuccess="getCallSuccess" :isAbnormal="isAbnormal"></UserPhone>
          </div>
          <div class="remark-panel">
            <div class="mask" v-if="$route.query.aliLogin"></div>
            <span class="remark-box">
              <span>需复核<el-switch v-model="isReview" style="margin-left: 10px;" @change="isReviewChange"></el-switch></span>
            </span>
            <!-- <UserRemark ref="userRemark" :taskId="getTaskCenterId" :patientData="patientData"></UserRemark> -->
            <RemarkInfo ref="remarkInfo" :taskId="getTaskCenterId" :patientData="patientData" :key="timer"
                        :patientTags="patientTags" @refreshTags="refreshTags"></RemarkInfo>
          </div>
          <div class="follow-status">
            <div v-if="$route.query.aliLogin" class="mask">
            </div>
            <div class="follow-status-top">
              <div v-if="showMask && hasFinsh " class="mask">
              </div>
              <div class="title-panel followup-status-title">
                <span class="label-title">随访情况</span>
                <div>
                  <el-button :disabled="patientData.incapableState == 2" @click="incapDialogVisible = true" type="info"
                             size="mini">加入黑名单
                  </el-button>
                  <el-button size="mini" type="danger" @click="abnormalOrAfter"
                             :disabled="workBenchCallStatus == 8 || workBenchCallStatus == 10  || isInReview"
                             :loading="abnormalLoading">异常/稍后
                  </el-button>
                </div>
              </div>
              <div class="label-container">
                <span class="title-panel-title">生存状态</span>
                <el-radio-group @change="changeIsDeathHandler" v-model="follow.isDeath"
                                :class="{'hasFinsh':hasFinsh}">
                  <el-radio :disabled="!hasFinsh" :label="1" :class="{'active':successFinsh}">生存
                  </el-radio>
                  <el-radio :disabled="!hasFinsh" :label="2" :class="{'active':successFinsh}">死亡
                  </el-radio>
                  <el-radio :disabled="!hasFinsh" :label="3" :class="{'active':successFinsh}">未知
                  </el-radio>
                </el-radio-group>
              </div>
              <div class="label-container">
                <span class="title-panel-title">随访状态</span>
                <el-radio-group v-model="follow.followStatus" @change="changeFollowupHandler"
                                :class="{'hasFinsh':hasFinsh}">
                  <el-radio :disabled="!follow.isDeath ||  follow.isDeath == 3" :label="9"
                            :class="{'active':successFinsh}">成功
                  </el-radio>
                  <el-radio :disabled="!follow.isDeath" :label="11"
                            :class="{'active':refuseFinsh}">未成功
                  </el-radio>
                  <el-radio :disabled="!follow.isDeath ||  follow.isDeath != 3" :label="10"
                            :class="{'active':!refuseFinsh && !successFinsh}"
                  >失访
                  </el-radio>
                </el-radio-group>
              </div>
              <div class="label-container" v-if="follow.followStatus == 11">
                <span class="title-panel-title" style="color: rgba(0, 0, 0, 0);">二级状态</span>
                <el-radio-group v-model="follow.refuseSecondStatus">
                  <el-radio :label="16">沟通不畅</el-radio>
                  <el-radio :label="17">拒绝随访（有信息）</el-radio>
                  <el-radio :label="18">拒绝随访（无信息）</el-radio>
                </el-radio-group>
              </div>
              <!-- <div v-else style="height: 35px;"></div> -->
              <div class="label-container">
                <span class="title-panel-title">随访方式</span>
                <el-radio-group v-model="followupTypeSign">
                  <el-radio :disabled="!hasFinsh" :label="0">电话
                  </el-radio>
                  <el-radio :disabled="!hasFinsh" :label="1"
                  >线上
                  </el-radio>
                  <el-radio :disabled="!hasFinsh" :label="2"
                  >电话+线上
                  </el-radio>
                </el-radio-group>
              </div>
              <div class="dethtime" v-if="follow.isDeath==2 && follow.followStatus">
                <!--<div class="dethtime">-->
                <el-form :model="follow" :rules="followRules" ref="followForm" label-width="100px">
                  <el-form-item label=" 死亡时间:" prop="deathTime">
                    <TimePicker :size="'mini'" :showDes="false" :date="follow.deathTime"></TimePicker>
                  </el-form-item>
                  <el-form-item label=" 死亡原因:" prop="deathReason">
                    <el-input type="textarea" :rows="4" maxlength="500" v-model="follow.deathReason"
                              autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="btn-wrapper">
              <el-button :disabled="workBenchCallStatus == 8 || workBenchCallStatus == 10" @click="finishAgainConfirm"
                         type="primary" :loading="finishConfirm">
                结束随访并保存
              </el-button>
              <div v-if="$route.query.abnormal==2">
                <el-checkbox v-model="autoToNext">结束随访时自动跳转至下一个</el-checkbox>
              </div>
            </div>
          </div>

        </div>
      </div>
      <el-dialog :close-on-click-modal="false"
                 title="请仔细确认呼叫状态"
                 :close-on-press-escape="false" :show-close="false"
                 :visible.sync="callRecordListVisible" :append-to-body="true" center>
        <el-table
            :data="callRecordList"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
        >
          <el-table-column
              prop="createTime"
              label="时间">
          </el-table-column>
          <el-table-column
              prop="phoneNumber"
              label="号码"
              width="180">
          </el-table-column>
          <!--<el-table-column-->
          <!--type="selection"-->
          <!--width="55">-->
          <!--</el-table-column>-->
          <el-table-column
              prop="relationshipRemarks"
              label="关系"
              width="180">
          </el-table-column>
          <el-table-column
              label="呼叫状态">
            <div slot-scope="scope">
              <!--<el-select @change="" v-if="scope.$index == 0" v-model="scope.row.callState" placeholder="请选择电话状态">-->
              <!--<el-option v-for="(item ,index) in phoneCallStateList" :key="index" :value="item.code"-->
              <!--:label="item.codeName"></el-option>-->
              <!--</el-select>-->
              <div>{{ getCallState(scope.row.callState) }}</div>
            </div>
          </el-table-column>
        </el-table>
        <div v-if="isRemind">
          <span>检测到通话时间较长的录音，为保证随访质量，建议听录音检查问卷后再提交。</span>
          <el-button @click="rebackVideo" type="text">去听录音</el-button>
        </div>
        <div style="display: flex;justify-content: center;margin-top: 15px;">
          <el-button @click="confirmRecordSelect" type="primary">确定</el-button>
          <el-button @click="cancelRecordSelect">返回修改</el-button>
        </div>
      </el-dialog>
      <el-dialog
          title="添加到收藏夹"
          :visible.sync="abnormalDialogShow"
          width="35%"
          class="abnormal-after-dialog"
      >
        <div class="content">
          <el-form :model="afterCallForm" ref="nextTimeForm" label-width="160px">
            <el-form-item label="选择异常类型：">
              <el-radio-group v-model="afterCallForm.type">
                <el-radio :label="1">异常随访</el-radio>
                <el-radio :label="2">稍后拨打</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="设置稍后拨打时间：" prop="afterCallTime" v-if="afterCallForm.type==2">
              <el-date-picker v-model="afterCallForm.afterCallTime" :value-format="'yyyy-MM-dd HH:mm:ss'"
                              type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="选择收藏夹：" class="fileId_selected">
              <el-radio-group v-model="afterCallForm.fileId" size="medium">
                <el-radio border
                          v-for="(item, index) in filetableData"
                          :key="index"
                          :label="item.id"
                          @click.native.prevent="handleDetailRemark(item.id)"
                >{{ item.fileName }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div style="text-align:right;">
            <el-button @click="abnormalDialogShow=false">取消</el-button>
            <el-button @click="tagConfirmHandle" type="primary">确定</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog width="500px" id="incapDialog" :visible.sync="incapDialogVisible" :close-on-click-modal="false"
                 title="加入黑名单">
        <div>
          <p style="margin-bottom: 5px;"><i style="color: red">*</i>加入黑名单原因</p>
          <el-input maxlength="500" v-model="incapReason" show-word-limit :rows="5" type="textarea"
                    placeholder="请输入将该患者加入黑名单原因"></el-input>
        </div>
        <div style="display: flex;justify-content: flex-end;margin-top: 10px;">
          <el-button @click="incapDialogVisible = false" size="mini">取消</el-button>
          <el-button @click="updateSuspectedIncapableState" size="mini" type='primary'>确定</el-button>
        </div>
      </el-dialog>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>
<script type="text/ecmascript-6">
// ==================abnormal状态=======================
// 3异常患者处理  4稍后随访   8 需复核 — 7收藏夹 6今日完成 5质控看板
//====================新问卷v3===================
import questionNew from '../question_Third/question'

import referenceInformation from '../referenceInformation/referenceInformation'
import followupHistoryList from '../referenceInformation/followupHistoryList'
// 患病者-- 资料页
import UserCard from '../patient/UserCard.vue'
import UserPhone from '../patient/UserPhone.vue'
// import UserRemark from '../patient/UserRemark.vue'
import RemarkInfo from '../patient/RemarkInfo.vue'
import Header from '../common/Header'
import Footer from '../common/Footer'
import PatientInHospital from '../patient/patientInHospital/patientInHospitalIndex' //患者报告列表
import lastFollowResult from '../followInfo/lastFollowResult'  // 上次随访结果
import _ from 'lodash'
import questionTreeNode from '../questionPreview/question-root-node-new'
import {
  RestFeedbackOutControllerIsRemind,
  RestNewFollowupCallCenterServiceGetFollowUpPatientCondition,
  RestNewFollowupCallCenterServiceGetTodayFollowupCount,
  RestFeedbackOutControllerUpdateRecordList,
  RestFeedbackOutControllerGetRecordList,
  RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo,// 获取随访任务患者信息
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfo,//获取随访任务异常患者信息
  RestNewFollowupCallCenterServiceGetIncompleteFollowupTaskPatientInfo,//获取随访任务未完成随访任务的患者信息
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfo,//稍后拨打
  RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList,// 获取患者的联系方式
  RestNewFollowupCallCenterServiceGetFollowupPatientRemarks,// 获取随访患者的备注
  RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks,// 更新随访患者的备注信息
  RestNewFollowupCallCenterServiceUpdateFollowupPatient,// 更新随访患者信息
  RestNewFollowupCallCenterServiceUpdateFollowupTaskAbnormalCall,// 设置患者为异常呼叫
  RestNewFollowupCallCenterServiceGetFollowupTaskReplayPatientInfo,
  RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo,
  RestReferenceControllerGetFollowupSpotCheckRemarksList,  //历史抽查记录
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList, //获取抽查列表
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList,
  RestFeedbackOutControllerAddFollowupQualityTime, //质控开始时间
  RestFeedbackOutControllerUpdateFollowupQualityTime, //质控结束时间
  RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater, //更新随访任务异常呼叫或稍后拨打
  RestFeedbackOutControllerGetFollowupPatientReview,
  RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo
} from "@src/assets/js/api.js";
import {mapGetters, mapMutations, mapState} from 'vuex';
import errorHandleMixin from "@mixins/errorHandleMixin";
import TimePicker from 'components/timePicker/indexNew.vue'

export default {
  name: 'callPatientMain',
  data() {
    var validateDeathTime = (rule, value, callback) => {
      console.log("fdsfasdfs", value);
      if (value && value.yearSelect) {
        callback();
      } else {
        callback("请选择患者死亡时间");
      }
    };
    return {
      incapReason: "",
      incapDialogVisible: false,
      activeName: this.$route.query.aliLogin ? "4" : "1",
      isRemind: false,
      // taskId: null,
      showMask: false,
      phoneCallStateList: [
        {code: 1, codeName: '稍后拨打'},
        {code: 2, codeName: '仅随访该号码'},
        {code: 3, codeName: '短信随访成功'},
        {code: 4, codeName: '电话随访成功'},
        {code: 5, codeName: '初始化'},
        {code: 6, codeName: '挂断（接通）'},
        {code: 7, codeName: '无人接听'},
        {code: 8, codeName: '挂断（未接通）'},
        {code: 9, codeName: '停机'},
        {code: 10, codeName: '关机'},
        {code: 11, codeName: '拒随'},
        {code: 12, codeName: '空号'},
        {code: 13, codeName: '错号'},
        {code: 14, codeName: '不知情'},
        {code: 15, codeName: '沟通不畅'}], // 电话状态列表
      finishStatus: '',
      followupTypeSign: 0,
      followupNum: null,
      confirmParams: {},
      multipleSelection: [],
      callRecordList: [],
      callRecordListVisible: false,
      showComponent: true,
      stretchall: false,
      qsSwich: false,// 是否展示全部问卷
      timeToNow: {},
      patientData: {},// 获取患者的信息
      saveRemarkIng: false,
      form: {
        remark: '',
      },
      confirmLoading: null,
      isCalling: false,
      follow: {
        isDeath: null,
        followStatus: "",
        refuseSecondStatus: "",
        deathTime: {},
        deathReason: "",
      },
      followRules: {
        deathTime: [
          {required: true, validator: validateDeathTime, trigger: 'blur'}
        ],
        deathReason: [
          {required: true, message: '请填写死亡原因', trigger: 'blur'}
        ],
      },
      relationShipListLoading: false,
      refuseFinsh: false,// 拒绝随访
      successFinsh: false,// 成功随访
      hasFinsh: true,
      abnormalLoading: false,// 点击异常患者loading
      finishConfirm: false,//点击结束随访患者loading
      qsLoaded: true,
      lostStatus: false,// 失访
      checklist: [],
      followupPatientId_p: '',//问卷  用
      followupQualityId: null, //质控时间 用
      abnormalDialogShow: false,
      afterCall: {
        afterCallChecked: false, //是否选择稍后拨打
        afterCallTime: null
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date)
            }
          },
          {
            text: '后天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周之后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date)
            }
          }
        ],
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      currentPatientId: null,
      isReview: false, //是否复核
      picLoading: false,
      targetData: "0/0",
      autoToNext: false,
      afterCallForm: {
        type: 1,
        afterCallTime: null,
        fileId: null
      },
      filetableData: [],
      timer: null,
      isRecord: false, //是否记录编辑问卷
      patientTags: [],
      canReview: false, // 能否进行“需复核”
      isInReview: false, // 需复核池/全部（需复核的），异常/稍后 禁用
      isReviewPool: false, //管理台是否开启需复核
    }
  },//
  computed: {
    ...mapGetters([
      'userid',
      'patientId',
      'taskValue',
      'username',
      'getTaskCenterId',
    ]),
    ...mapState([
      'workBenchCallStatus',
      'taskId',
      'nextCallNumberId',
      'currentCallNumberId',
      'currentCallNumber',
      'follupTime',
      'follupTimeString',
      'contactId',
      'contactSuccessIds',
      'taskType'
    ]),
    canFinnishBtn() { //完成按钮
      if (this.hasFinish) {
        return false;
      } else {
        return true;
      }
    },
    taskType() {
      let taskType = this.$route.query.taskType && parseInt(this.$route.query.taskType, 10) || ''
      return taskType;
    },
    isAbnormal() { // 患者是正常或者异常
      return this.$route.query.abnormal != 3; //!=3是正常 3是异常
    },
  },
  watch: {
    $route: { // 监听路由的参数变化
      handler(val, old_val) { // 数据变化更新数据
        if (old_val && old_val.query.followupPatientId != val.query.followupPatientId) {
          console.log("old_val=====>", old_val);
          console.log("val=====>", val);
          this.isRecord = val.query.type == 1 || val.query.type == 2 || val.query.type == 4 //质控看板的数据修改问卷要记录
          if (val.query.abnormal == 2) { //能否进行需复核（开始随访、异常、稍后）
            this.canReview = true
          } else if (val.query.isAll && (val.query.isAll == '3' || val.query.isAll == '4')) {  //未完成随访-全部(异常稍后可以)
            this.canReview = true
          } else if (val.query.abnormal == '3' || val.query.abnormal == '4' || val.query.abnormal == '7') {  //未完成随访-异常/稍后/收藏池
            this.canReview = true
          } else if (val.query.type == '1' || val.query.type == '4') { // 质控看板-需重拨/需注意
            this.canReview = true
          } else {
            this.canReview = false
          }
          if ((this.$route.query.isAll && this.$route.query.isAll == '8') || this.$route.query.abnormal == '8') {
            this.isInReview = true
          }

          this.getPatientData();
          this.getPatientRecord();
          this.getReferenceInfo();
          this.getFollowHistory();
          this.getUserCard();
          this.getTodayFollowupNum()
          this.asyncGetStatis()
        }

      },
      immediate: true // 立即执行
    }

  },// 实时监听
  mixins: [errorHandleMixin],
  components: {
    questionNew,
    Header,
    Footer,
    UserCard,
    UserPhone,
    TimePicker,
    PatientInHospital,
    lastFollowResult,
    questionTreeNode,
    referenceInformation,
    followupHistoryList,
    RemarkInfo

  },

  // ==========进入页面时和离开页面时========
  beforeRouteLeave(to, from, next) {
    let vm = this
    if (vm.isCalling) {
      window.workbench && window.workbench.hangUp();
      this.setCurrentCalling(false)
    }
    // this.updateFollowupQualityTimeAsync()
    next();
  },// this.displaySettingItem(function () => { function addItem() => { console.log()}})
  mounted() {
    let vm = this

    window.pubsub && window.pubsub.off('calling').on('calling', function () {
      console.log('-------user -- phone -- calling ', arguments)
      this.finishStatus = ""
      vm.isCalling = true;
    });
    window.pubsub && window.pubsub.off('callHangUp').on('callHangUp', function () {
      this.finishStatus = ""
      console.log('-----user -- phone --- callHangUp ', arguments)
      vm.isCalling = false;
    });
    this.followupTaskId = this.getTaskCenterId
    this.isRecord = this.$route.query.isRecord ? true : false || this.$route.query.type == 1 || this.$route.query.type == 2 || this.$route.query.type == 4 //质控看板的数据修改问卷要记录

    if (this.$route.query.abnormal == 2) { //能否进行需复核（开始随访、异常、稍后）
      this.canReview = true
    } else if (this.$route.query.isAll && (this.$route.query.isAll == '3' || this.$route.query.isAll == '4')) {  //未完成随访-全部(异常稍后可以)
      this.canReview = true
    } else if (this.$route.query.abnormal == '3' || this.$route.query.abnormal == '4' || this.$route.query.abnormal == '7') {  //未完成随访-异常/稍后/收藏池
      this.canReview = true
    } else if (this.$route.query.type == '1' || this.$route.query.type == '4') { // 质控看板-需重拨/需注意
      this.canReview = true
    } else {
      this.canReview = false
    }

    if ((this.$route.query.isAll && this.$route.query.isAll == '8') || this.$route.query.abnormal == '8') {
      this.isInReview = true
    }


    // 因为可能修改 bug  ，热更新 没有获取到值
    this.getPatientData();
    this.getPatientRecord();
    this.getReferenceInfo();
    this.getFollowHistory();
    this.getUserCard();
    this.getTodayFollowupNum()
    this.asyncGetStatis()
    // 获取新手保护时间
    this.getNewGuardTime()
  },
  methods: {
    ...mapMutations([
      "setCurrentPage",
      "setcurrentPatient",
      "setCurrentTaskId",
      "setTaskType",
      "resetPatient",
      'removeContactId',
      'removeContactIds',
      "setCurrentCalling",
      "resetCallBackPatient"
    ]),
    updateSuspectedIncapableState() {
      if (!this.incapReason) {
        this.$message.error('加入黑名单原因不可为空')
        return false
      }
      this.updateIncapStatus(this.incapReason)
      // this.$prompt('加入黑名单原因', '加入黑名单', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputPlaceholder: '请输入将该患者加入黑名单原因',
      //   inputType: 'textarea',
      //   inputPattern: /^[a-zA-Z0-9\s]{1,500}$/,
      //   inputErrorMessage: '加入黑名单原因不可为空'
      // }).then(({ value }) => {
      //   this.updateIncapStatus(value)
      // }).catch(() => {
      // });
    },
    updateIncapStatus(value = "") {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceUpdateSuspectedIncapableState',
        params: {
          incapableReason: value || null,
          confirmName: this.username,
          confirmId: this.userid,
          followupPatientId: this.patientData.followupPatientId,
          followUpTaskId: this.getTaskCenterId,
        }
      }).then(res => {
        if (res.retValue == 'SUCCESS') {
          this.$message.success('加入黑名单成功')
          this.incapDialogVisible = false
        } else {
          this.$message.error('加入黑名单失败')
        }
      })
      //设备维护
    },
    saveCurrentPage() {
      this.$refs.questionTreeNode.bantchSaveAnswer()
    },
    //去听录音
    rebackVideo() {
      this.callRecordListVisible = false
      this.$refs.userphone.rebackVideoAuto()
      this.finishConfirm = false
      // let isLast =
    },
    getCallState(status) {
      console.log(this.phoneCallStateList.find(item => item.code == status));
      return this.phoneCallStateList.find(item => item.code == status).codeName
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => {
        return item.id
      });
    },
    // // 添加质控时间--开始
    // addFollowupQualityTime(fpid) {
    //   this.addFollowupQualityTimeAsync(fpid).then(res => {
    //     console.log("质控开始")
    //     this.followupQualityId = res.retValue
    //   });
    // },

    //生存状态切换
    changeIsDeathHandler() {
      this.follow.followStatus = ""
    },
    // 随访状态切换
    changeFollowupHandler() {
      this.follow.refuseSecondStatus = ""
    },
    confirmRecordSelect() {
      this.confirmLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.setCurrentPage(100)
      if (this.multipleSelection.length) {
        this.updateRecordList({ids: this.multipleSelection})
            .then(res => {
              if (res.status == 0) {
                this.$message.success('提交成功')
              }
            })
      }
      this.callRecordListVisible = false
      this.confirmParams.spotCheckId = this.$route.query.spotCheckId

      this.asyncUpdatePatientFollowResult(this.confirmParams).then(res => {
        console.log('this.$route.query.abnormal----》', this.$route.query.abnormal);
        if (res.status == 0) {
          if (this.$route.query.abnormal == 3) {
            console.log("稍后池中的结束并保存，患者池下一个")

            this.updateNextAbnormalPatient();
          } else if (this.$route.query.abnormal == 4) {
            console.log("异常池中的结束并保存，患者池下一个")
            this.updateNextCallLaterPatient();
          } else if (this.$route.query.abnormal == 8) {
            console.log("需复核池中的结束并保存，患者池下一个")
            this.updateNextReviewPatient();
          } else if (this.$route.query.abnormal == -1) {
            console.log("abnormal == -1，下一个")
            this.updateNextAllAbPatient()
          } else if (this.$route.query.abnormal == 7) { //收藏夹中的患者
            this.nextExceptionGo()
          }
        }
      })
      if (!this.autoToNext) {
        this.goBoardPage()
      }
      this.follow.isDeath = ""
      this.follow.followStatus = ""
      let questionBaseInfo = JSON.parse(localStorage.getItem('questionBaseInfo')) || []
      if (questionBaseInfo.length) {
        let index = questionBaseInfo.findIndex(item => item.NO === this.admitNo)
        questionBaseInfo.splice(index, 1)
        localStorage.setItem('questionBaseInfo', JSON.stringify(questionBaseInfo))
      }
      this.refreshComponent();
      this.confirmLoading.close()
    },
    cancelRecordSelect() {
      this.callRecordListVisible = false
      this.finishConfirm = false
    },
    //获取呼叫记录列表
    async getCallListAsync(p) {
      let request = new RestFeedbackOutControllerGetRecordList()
      request.p_followUpPatientInfoId = p.followUpPatientInfoId
      await request.send()
      return request.result
    },
    //提交呼叫记录RestFeedbackOutControllerUpdateRecordList
    async updateRecordList(p) {
      let request = new RestFeedbackOutControllerUpdateRecordList()
      request.p_ids = p.ids
      await request.send()
      return request.result
    },
    async getTodayFollowupNum() {
      let request = new RestNewFollowupCallCenterServiceGetTodayFollowupCount()
      request.p_seatId = sessionStorage.getItem('userid')
      request.p_taskId = this.getTaskCenterId
      await request.send()
      if (request.result.status == 0) {
        this.followupNum = request.result.retValue
      }
    },
    getNewGuardTime() {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetNoviceProtectionEndTime',
        params: {
          seatId: this.userid,
          followUpTaskId: this.getTaskCenterId
        }
      }).then(res => {
        if (res.status == 0 && res.retValue) {
          localStorage.setItem('noviceProtectionEndTime', res.retValue)
        } else {
          localStorage.setItem('noviceProtectionEndTime', "")
        }
      })
    },
    //=================================userPhone=========================
    getCallSuccess(callSuccess) {
      console.log("callSuccess11111111----------", callSuccess)
    },
    /**
     * 处理挂断组件-完成
     */
    getOverFollowUp(finshStatus) {
      console.log('[finshStatus]', finshStatus == 'successFinsh');
      this.finishStatus = finshStatus
      // if (finshStatus) {
      //   this['finshStatus'] = true;
      //   if (finshStatus != 'lostStatus') {
      //     this.lostStatus = false
      //   }
      // } else {
      //   this.lostStatus = false
      // }
      // //异常患者处理失访逻辑
      // if (!this.isAbnormal) {
      //   if (this.refuseFinsh || this.successFinsh) {
      //     this.lostStatus = false
      //   }
      // } else {
      //   // 正常患者
      //   if (finshStatus == 'lostStatus') {
      //     this.refuseFinsh = false
      //     this.successFinsh = false
      //   }
      //
      // }
      this.hasFinsh = true
      this.showMask = false
    },
    /**
     * 完成时候由子组件触发
     */
    getPatientData() {
      let vm = this
      this.initBaseData()
          .then(() => {
            if (this.$refs['userphone']) {
              this.$refs['userphone'].isModel = 'beMessage';
            }
            console.log("this.$route.query.abnormal========>", this.$route.query);
            this.followupPatientId_p = this.$route.query.followupPatientId;
            if (this.$route.query.isCallBack) {
              this.resetCallBackPatient()
              // this.getCallBackPatientInfos()
            } else {
              // 获取  当前用户  当前 taskType  1.随访 2.通知 3.回访 4.重播
              this.resetPatient();
              this.getCurrentPatientInfo()
                  .then(() => {
                    // vm.$refs.userRemark.onLoad()
                    this.qsLoaded = true
                  })
            }
          })

    },
    manualCall() {
      console.log("header===>refs", this.$refs.header)
      this.$refs.header.setCallingStatus()
    },
    manualCallBack(callNumber) {
      console.log("header===>refs", this.$refs.header, callNumber)
      this.$refs.userphone.manualCallBack(callNumber)
    },
    // 挂断后 ===  userPhone
    userPhoneAfterStatus() {
      this.$refs['userphone'].setCallHangUpStatusDialog();
    },
    //  保存的触发点设置为离开该随访人
    saveRemark() {
      // 重新刷新 患者hh
      this.getPatientData();
    },
    //===============================患者====================================
    initBaseData() {
      return new Promise((resolve => {
        let vm = this;
        this.refuseFinsh = false;
        this.successFinsh = false;
        this.hasFinsh = true;
        // this.hasFinsh = false;
        this.follow.followStatus = ""
        this.follow.refuseSecondStatus = ""
        this.follow.isDeath = ""
        this.follow.deathTime = {}
        this.follow.deathReason = ""
        this.qsLoaded = false
        resolve()
      }))

    },
    getCurrentPatientInfo() {
      return new Promise((async resolve => {
        let vm = this;
        let params = {
          userId: this.userid
        };
        if (typeof params.userId === "undefined") {
          vm.errorHandle({message: "无法获取操作人员的ID,请重新登录"});
          return false;
        }
        this.relationShipListLoading = true;
        this.autoToNext = true
        if (this.$route.query.abnormal == 2) {
          //TODO 正常患者处理
          await this.asyncGetNormalPatientInfo(params).then((data) => {
            if (data.status == 0) {
              vm.patientData = data.retValue || {}
              vm.setcurrentPatient(data.retValue);
              this.followupPatientId_p = data.retValue.followupPatientId; //查询问卷所需的followupPatientId
              vm.setCurrentTaskId(data.retValue.id);
              //获取患者的联系方式
              vm.asyncGetPatientContacks(data.retValue.patientId);
              vm.currentPatientId = data.retValue.patientId
              // 获取患者的备注信息
              vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
              vm.getPatientRecord()
              vm.refreshComponent()
              this.getReferenceInfo();
              this.getFollowHistory();
              this.getUserCard();
              this.getRemarksList(data.retValue.followupPatientId);
              vm.getLastResult()
              // this.addFollowupQualityTime(data.retValue.followupPatientId);
              vm.asyncGetStatis()
              vm.getFollowupPatientReviewAsync(); //复核
            } else if (data.status == -8) {
              this.getCurrentPatientInfo()
            }
          }).catch(err => {
            vm.errorHandle(err);
            this.relationShipListLoading = false;
          })

        } else if (this.$route.query.abnormal == 3 || this.$route.query.abnormal == 8) {
          //TODO 异常患者处理3
          let p = {
            patientId: this.$route.query.patientId,
            followupPatientId: this.$route.query.followupPatientId,
            followUpPatientInfoId: this.$route.query.followUpPatientInfoId
          }
          await this.asyncGetAbNormalPatientInfo(p).then((data) => {
            if (data.status == 0) {
              vm.patientData = data.retValue || {}
              vm.setcurrentPatient(data.retValue);
              vm.setCurrentTaskId(data.retValue.id);
              //获取患者的联系方式
              vm.asyncGetPatientContacks(data.retValue.patientId);
              vm.currentPatientId = data.retValue.patientId
              // 获取患者的备注信息
              vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
              vm.getPatientRecord()
              vm.refreshComponent()
              this.getReferenceInfo();
              this.getFollowHistory();
              this.getUserCard();
              this.getRemarksList(data.retValue.followupPatientId);
              vm.getLastResult()
              // this.addFollowupQualityTime(data.retValue.followupPatientId);
              vm.getFollowupPatientReviewAsync(); //复核
              vm.asyncGetStatis()
            }
          }).catch(err => {
            vm.errorHandle(err);
            this.relationShipListLoading = false;
          })
        } else if (this.$route.query.abnormal == 4) {
          //TODO 稍后拨打4
          let p = {
            patientId: this.$route.query.patientId,
            followupPatientId: this.$route.query.followupPatientId,
            followUpPatientInfoId: this.$route.query.followUpPatientInfoId
          }
          await this.asyncGetcallLaterNumberPatientInfo(p).then((data) => {
            if (data.status == 0) {
              vm.patientData = data.retValue || {}
              vm.setcurrentPatient(data.retValue);
              vm.setCurrentTaskId(data.retValue.id);
              //获取患者的联系方式
              vm.asyncGetPatientContacks(data.retValue.patientId);
              vm.currentPatientId = data.retValue.patientId
              // 获取患者的备注信息
              vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
              vm.getPatientRecord()
              vm.refreshComponent()
              this.getReferenceInfo();
              this.getFollowHistory();
              this.getUserCard();
              this.getRemarksList(data.retValue.followupPatientId);
              vm.getLastResult()
              // this.addFollowupQualityTime(data.retValue.followupPatientId);
              vm.getFollowupPatientReviewAsync(); //复核
              vm.asyncGetStatis()
            }
          }).catch(err => {
            vm.errorHandle(err);
            this.relationShipListLoading = false;
          })
        } else if (this.$route.query.abnormal == -1) {
          let p = {
            patientId: this.$route.query.patientId,
            followupPatientId: this.$route.query.followupPatientId,
            followUpPatientInfoId: this.$route.query.followUpPatientInfoId
          }
          await this.getPatientInfoByAll(p, this.$route.query.isAll).then((data) => {
            if (data.status == 0) {
              vm.patientData = data.retValue || {}
              vm.setcurrentPatient(data.retValue);
              vm.setCurrentTaskId(data.retValue.id);
              //获取患者的联系方式
              vm.asyncGetPatientContacks(data.retValue.patientId);
              vm.currentPatientId = data.retValue.patientId
              // 获取患者的备注信息
              vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
              vm.getPatientRecord()
              vm.refreshComponent()
              this.getReferenceInfo();
              this.getFollowHistory();
              this.getUserCard();
              this.getRemarksList(data.retValue.followupPatientId);
              vm.getLastResult()
              // this.addFollowupQualityTime(data.retValue.followupPatientId);
              vm.getFollowupPatientReviewAsync(); //复核
              vm.asyncGetStatis()
            }
          }).catch(err => {
            vm.errorHandle(err);
            this.relationShipListLoading = false;
          })
        } else if (this.$route.query.abnormal == 5) {
          var p = {
            userId: this.userid,
            followupPatientId: this.$route.query.followupPatientId,
            followUpPatientInfoId: this.$route.query.followUpPatientInfoId
          }
          await this.getFollowupTaskReplayPatientInfoAsync(p)
              .then(data => {
                if (data.status == 0) {
                  vm.patientData = data.retValue || {}
                  vm.setcurrentPatient(data.retValue);
                  vm.setCurrentTaskId(data.retValue.id);
                  //获取患者的联系方式
                  vm.asyncGetPatientContacks(data.retValue.patientId);
                  vm.currentPatientId = data.retValue.patientId
                  // 获取患者的备注信息
                  vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
                  vm.getPatientRecord()
                  vm.refreshComponent()
                  this.getReferenceInfo();
                  this.getFollowHistory();
                  this.getUserCard();
                  this.getRemarksList(data.retValue.followupPatientId);
                  vm.getLastResult()
                  // this.addFollowupQualityTime(data.retValue.followupPatientId);
                  vm.getFollowupPatientReviewAsync(); //复核
                  vm.asyncGetStatis()
                }
              })
        } else if (this.$route.query.abnormal == 6) {
          let params = {
            followupState: this.$route.query.followupState,
            followupTaskId: this.getTaskCenterId,
            followupPatientId: this.$route.query.followupPatientId,
          }
          await this.asyncGetFollowUpTodayCompletePatientInfo(params)
              .then(data => {
                if (data.status == 0) {
                  vm.patientData = data.retValue || {}
                  vm.setcurrentPatient(data.retValue);
                  vm.setCurrentTaskId(data.retValue.id);
                  //获取患者的联系方式
                  vm.asyncGetPatientContacks(data.retValue.patientId);
                  vm.currentPatientId = data.retValue.patientId
                  // 获取患者的备注信息
                  vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
                  vm.getPatientRecord()
                  vm.refreshComponent()
                  this.getReferenceInfo();
                  this.getFollowHistory();
                  this.getUserCard();
                  this.getRemarksList(data.retValue.followupPatientId);
                  vm.getLastResult()
                  // this.addFollowupQualityTime(data.retValue.followupPatientId);
                  vm.getFollowupPatientReviewAsync(); //复核
                  vm.asyncGetStatis()
                }
              })
        } else if (this.$route.query.abnormal == 7) {
          // 未完成随访收藏夹功能，需要判断患者来源（异常1/稍后2）
          let p = {
            patientId: this.$route.query.patientId,
            followupPatientId: this.$route.query.followupPatientId,
            followUpPatientInfoId: this.$route.query.followUpPatientInfoId
          }
          if (this.$route.query.collectSource == 1) {
            await this.asyncGetAbNormalPatientInfo(p).then((data) => {
              if (data.status == 0) {
                this.getPatientInfoAfter(data)
              }
            }).catch(err => {
              vm.errorHandle(err);
              this.relationShipListLoading = false;
            })
          } else if (this.$route.query.collectSource == 2) {
            await this.asyncGetcallLaterNumberPatientInfo(p).then((data) => {
              if (data.status == 0) {
                this.getPatientInfoAfter(data)
              }
            }).catch(err => {
              vm.errorHandle(err);
              this.relationShipListLoading = false;
            })
          }
        } else {
          //TODO 其他情况处理（未完成随访的患者）
          await this.asyncGetIncompletePatientInfo(params).then((data) => {
            if (data.status == 0) {
              vm.patientData = data.retValue || {}
              vm.setcurrentPatient(data.retValue);
              vm.setCurrentTaskId(data.retValue.id);
              //获取患者的联系方式
              vm.asyncGetPatientContacks(data.retValue.patientId);
              vm.currentPatientId = data.retValue.patientId
              // 获取患者的备注信息
              vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
              vm.getPatientRecord()
              vm.refreshComponent()
              this.getReferenceInfo();
              this.getFollowHistory();
              this.getUserCard();
              this.getRemarksList(data.retValue.followupPatientId);
              vm.getLastResult()
              // this.addFollowupQualityTime(data.retValue.followupPatientId);
              vm.getFollowupPatientReviewAsync(); //复核
              vm.asyncGetStatis()
            }
          }).catch(err => {
            vm.errorHandle(err);
            this.relationShipListLoading = false;
          })

        }
        this.timer = new Date().getTime()
        this.relationShipListLoading = false
        resolve()
      }))
    },
    getPatientError() {
      // 获取任务信息失败
      let vm = this;
      vm.$router.go(-1)
    },
    getPatientInfoAfter(data) {
      let vm = this
      vm.patientData = data.retValue || {}
      vm.setcurrentPatient(data.retValue);
      vm.setCurrentTaskId(data.retValue.id);
      //获取患者的联系方式
      vm.asyncGetPatientContacks(data.retValue.patientId);
      vm.currentPatientId = data.retValue.patientId
      // 获取患者的备注信息
      vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
      vm.getPatientRecord()
      vm.refreshComponent()
      this.getReferenceInfo();
      this.getFollowHistory();
      this.getUserCard();
      this.getRemarksList(data.retValue.followupPatientId);
      vm.getLastResult()
      // this.addFollowupQualityTime(data.retValue.followupPatientId);
      vm.getFollowupPatientReviewAsync(); //复核
      vm.asyncGetStatis()
    },
    abnormalOrAfter() {
      // 异常/稍后 
      // this.getPatientContacksAsync().then(res => {
      //   let temp = res.retValue.find(item => item.lastCallState == 1)
      //   if (temp) {
      //     this.getPatientContacksAsync().then(res => {
      //       let temp = res.retValue.filter(item => {
      //         return item.laterCallTime
      //       })
      //       if (temp.length > 0) {
      //         this.afterCallForm.type = 2//是否选择稍后拨打
      //         this.afterCallForm.afterCallTime = temp[0].laterCallTime
      //       }
      //     })
      //   } else {
      //     this.afterCallForm.type = 1
      //     this.afterCallForm.afterCallTime = null
      //   }
      // })
      this.afterCallForm.type = 1
      this.afterCallForm.afterCallTime = null
      // 收藏夹
      this.getExceptionFile()
    },
    getExceptionFile() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestAbnormalFollowupFileControllerGetExceptionFile',
            params: {
              seatId: this.userid,
              taskId: this.getTaskCenterId,
              followupPatientId: this.patientData.followupPatientId
            }
          }
      ).then(res => {
        if (res.status == 0 && res.retValue.length > 0) {
          this.filetableData = res.retValue
          let _filedata = res.retValue.find(item => item.isExit)
          if (_filedata) {
            this.afterCallForm.fileId = _filedata.id
          } else {
            this.afterCallForm.fileId = null
          }
        } else {
          this.filetableData = []
        }
        this.abnormalDialogShow = true;
      })
    }, //
    afterCallChangeHandle() {
      if (!this.afterCall.afterCallChecked) {
        this.afterCall.afterCallTime = null
      }
    },
    nextTimeValidator(rule, value, callback) {
      if (value) {
        let selectTime = new Date(value).getTime()
        let now = new Date().getTime();
        if (selectTime < now) {
          callback('选择的时间必须为未来时间')
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    tagConfirmHandle() {
      if (!this.getTaskCenterId) {
        this.$message.error("缺失taskId，请重新登录")
        return
      }
      this.setCurrentPage(100)
      if (this.afterCallForm.type == 2 && !this.afterCallForm.afterCallTime) {
        this.$message.warning("请选择稍后拨打日期")
        return
      }
      // 将患者添加到指定文件夹
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestAbnormalFollowupFileControllerAddPatientToFile',
            params: {
              seatId: this.userid,
              taskId: this.getTaskCenterId,
              followupPatientId: this.patientData.followupPatientId,
              fileId: this.afterCallForm.fileId,
              followupPatientInfoId: this.patientData.followUpPatientInfoId,
              source: this.afterCallForm.type,
            }
          }
      ).then(res => {
        if (res.status == 0) {
          if (this.afterCallForm.fileId) {
            this.$message.success("添加到收藏夹成功！")
          }
          if (this.$route.query.abnormal == 7 && this.$route.query.tabIndex) {
            if(this.afterCallForm.type == 2) {
              this.abnormalOrAfterGo()
            }
            this.nextExceptionGo()
          } else {
            this.abnormalOrAfterGo()
          }
        } else {
          this.$message.error(res.desc)
        }
      })
    },
    abnormalOrAfterGo() {
      this.updateAbnormalCallOrCallLaterAsync().then(res => {
        this.abnormalDialogShow = false
        if (!this.autoToNext) {
          this.goBoardPage()
        } else {
          // 稍后拨打页和异常患者页中--稍后拨打
          if (this.$route.query.abnormal == 3 && this.autoToNext) {
            console.log("异常患者，需要进入下一患者了");
            this.updateNextAbnormalPatient();
          } else if (this.$route.query.abnormal == 4 && this.autoToNext) {
            console.log("稍后患者，需要进入下一患者了");
            this.updateNextCallLaterPatient();
          } else if (this.$route.query.abnormal == 8) {
            console.log("需复核池中，添加到需复核池"); // 当前需复核池中，需复核不可点，不存在此情况
          } else if (this.$route.query.abnormal == -1 && this.autoToNext) {
            console.log("全部患者，需要进入下一患者了");
            this.updateNextAllAbPatient();
          } else {
            console.log("开始随访下一个")
            this.getPatientData();
            this.getPatientRecord();
            this.getReferenceInfo();
            this.getFollowHistory();
            this.getUserCard();
            this.getTodayFollowupNum()
            this.asyncGetStatis()
          }
        }
      })
    },
    handleDetailRemark(val) {
      val == this.afterCallForm.fileId ? this.afterCallForm.fileId = null : this.afterCallForm.fileId = val
      this.$forceUpdate()
    },
    goBoardPage() {
      this.$router.push({
        path: "/taskDetail",
        query: {
          diseaseId: this.$route.query.diseaseId,
          isRemindStudy: this.$route.query.isRemindStudy,
          isSingleDuration: this.$route.query.isSingleDuration,
          isTotalDuration: this.$route.query.isTotalDuration,
          type: this.$route.query.type ? this.$route.query.type : ''
        }
      });
    },
    getIsDeath(val) {
      switch (val) {
        case 1:
          return false;
          break
        case 2:
          return true;
          break
        case 3:
          return false;
          break
      }
    },
    // 点击完成
    finishAgainConfirm() {
      if (!this.getTaskCenterId) {
        this.$message.error("缺失taskId，请重新登录")
        return
      }
      let vm = this;
      if ([9, 10, 11].indexOf(this.follow.followStatus) == -1) {
        this.$message.error('随访状态未选择')
        return
      }
      if (this.follow.followStatus == 11 && [16, 17, 18].indexOf(this.follow.refuseSecondStatus) == -1) {
        this.$message.error('随访状态未选择完整')
        return
      }
      this.saveCurrentPage()
      vm.$refs.userphone.checkSubmitStatus()
          .then(res => {
            if (res) {
              var messageObj = {
                9: 3,
                10: 2,
                11: 1,
                12: 0,
              }
              var params = {
                userId: this.userid,
                followupPatientId: vm.patientData.followupPatientId,
                followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
                followupTaskId: this.getTaskCenterId,
                followupState: vm.follow.followStatus != 11 ? vm.follow.followStatus : vm.follow.refuseSecondStatus,
                followupMode: vm.$refs.userphone.followupModeChecked ? 2 : 1,
                followupCooperate: messageObj[vm.follow.followStatus],
                followupType: 2,
                isDeath: this.getIsDeath(this.follow.isDeath),
                followupTime: "",
                followupTypeSign: this.followupTypeSign,
                followupSource: this.$route.query.followupSource || 1,
                // refuseSecondStatus: vm.follow.refuseSecondStatus,
                newExistenceState: this.follow.isDeath ? this.follow.isDeath - 1 : null
              }
              console.log("params---->", params)
              if (this.follow.isDeath == 2) {
                vm.$refs['followForm'].validate((valid) => {
                  if (valid) {
                    params.isDeath = true;
                    params.deathTime = vm.follow.deathTime.yearSelect + '-' + vm.follow.deathTime.monthSelect + '-' + vm.follow.deathTime.daySelect
                    params.deathReason = vm.follow.deathReason
                    this.sureFinshPatient(params)
                  }
                })
              } else {
                this.sureFinshPatient(params)
              }
            } else {
              return
            }
          })
      this.isRemindAsync()
          .then(res => {
            console.log(res);
            this.isRemind = res.retValue
          })
    },
    hideCode(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    },
    sureFinshPatient(params) {
      let vm = this;
      if (!vm.finishConfirm) {
        vm.finishConfirm = true;
        // vm.$refs.userRemark.submitResult()
        this.getCallListAsync({followUpPatientInfoId: this.patientData.followUpPatientInfoId})
            .then(res => {
              console.log(res);
              this.confirmParams = params
              this.callRecordListVisible = true
              this.callRecordList = res.retValue.map(item => {
                item.contactTime = this.secondText(item.contactTime)
                item.phoneNumber = this.hideCode(item.phoneNumber + "", 3, 4)
                return item
              })
            })
        //TODO   确认 按钮
        //坑
      }
    },
    secondText(val) {
      let value = val;
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时
      if (theTime >= 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle >= 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result =
          parseInt(theTime) < 10
              ? "0" + parseInt(theTime)
              : "" + parseInt(theTime);
      var middleText =
          parseInt(middle) < 10 ? "0" + parseInt(middle) : "" + parseInt(middle);
      result = middleText + ":" + result;
      if (hour > 0) {
        result = parseInt(hour) + ":" + result;
      }
      return result;
    },
    refreshComponent() {
      this.showComponent = false
      setTimeout(() => {
        this.getTodayFollowupNum()
        this.$refs.userphone.callReturnId = null
        this.showComponent = true
        console.log('callReturnId', this.$refs.userphone.callReturnId);
      }, 200)
      this.$forceUpdate()

    },
    /**
     * 获取患者的检查报告
     */
    getPatientRecord() {
      let vm = this;
      if (vm.$refs['patientRecord']) {
        vm.$refs['patientRecord'].getRecrods()
      }
    },
    getReferenceInfo() {
      let vm = this;
      if (vm.$refs['referenceInfo']) {
        vm.$refs['referenceInfo'].getReferenceInfo()
      }
    },
    getFollowHistory() {
      let vm = this;
      if (vm.$refs['followHistory']) {
        vm.$refs['followHistory'].getReferenceInfo()
      }
    },
    getUserCard() {
      let vm = this;
      if (vm.$refs['userCard']) {
        vm.$refs['userCard'].init()
      }
    },
    getRemarksList(id) {
      let vm = this;
      let params = {
        followUpPatientId: vm.$route.query.followupPatientId || id,
        followupTaskId: vm.getTaskCenterId
      }
      vm.getFollowupSpotCheckRemarksListAsync(params).then(res => {
        this.checklist = res.retValue;

        this.checklist = res.retValue.map(item => {
          item.handleResultName = this.getHandleresult(item.handleResult);
          let stateArr = item.firstSpotCheckState.substr(1, item.firstSpotCheckState.length - 2).split(',');
          stateArr = stateArr.map(it => {
            return this.getSpotCheckState(it)
          })
          item.firstSpotCheckStateStr = stateArr.join(',')
          // 处理图片
          item.imageUrlAfter = []
          this.getPicUrl(item.imageUrl)
              .then(pic => {
                item.imageUrlAfter = pic
                this.picLoading = true
              })
          return item
        })
      });
    },
    // 获取图片
    getPicUrl(picList) {
      return new Promise((resolve) => {
        this.$store.dispatch('getPicture', {url: picList}).then((res_) => {
          resolve(res_)
        })
      })
    },
    getSpotCheckState(state) {
      switch (state) {
        case '8':
          return '收集不足';
          break
        case '9':
          return '态度欠佳';
          break
        case '10':
          return '录音缺失';
          break
        case '11':
          return '记录有误';
          break
        case '15':
          return '逻辑清晰';
          break
        case '16':
          return '收集完整';
          break
        case '17':
          return '态度良好';
          break
        case '18':
          return '记录准确';
          break

        case '21':
          return '混乱无序';
          break
        case '22':
          return '清楚流利';
          break
        case '23':
          return '生疏含混';
          break
        case '24':
          return '积极灵活';
          break
        case '25':
          return '刻板迟钝';
          break
      }
    },
    getHandleresult(state) {
      switch (state) {
        case 1:
          return '需重拨'
          break
        case 2:
          return '需注意'
          break
        case 3:
          return '平台相关'
          break
        case 4:
          return '需修改问卷'
          break
      }
    },
    /**
     * 获取患者上次的随访记录
     */
    getLastResult() {
      let vm = this;
      if (vm.$refs['lastFollowResult']) {
        vm.$refs['lastFollowResult'].asyncGetFollowResultByAdminNo({admitNo: this.patientData.admitNo})
      }
    },
    judgeStatus(status) {
      if (this.$route.query.abnormal == 5 || this.$route.query.abnormal == 6) {
        this.$router.go(-1)
        return
      } else {
        var messageObj = {
          9: '本患者已经标记为完成状态，获取下一个患者信息',
          10: '本患者已经标记为失访状态，获取下一个患者信息',
          11: '本患者已经标记为拒绝随访状态，获取下一个患者信息',
          12: '本患者已经标记为死亡状态，获取下一个患者信息',
          5: '本患者进入任务池，获取下一个患者信息',
        }
        this.$notify({
          title: '提示',
          message: messageObj[status],
          duration: 3000
        });
        this.$refs.userphone.followupModeChecked = false
        this.saveRemark();
      }
    },
    updateNextReviewPatient() {
      this.$store.dispatch('requestHandler', {
        fn: "RestNewFollowupCallCenterServiceGetReviewFollowupTaskPatientInfoList",
        params: {
          userId: this.userid,
          followupTaskId: this.getTaskCenterId,
          pageIndex: this.$route.query.pageIndex,
          pageSize: 10,
        }
      }).then(res => {
        if (res.retValue.length > 0) {
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index)
          if (nextPatieint) {
            if (this.$route.query.followupPatientId == nextPatieint.followupPatientId) {
              this.goBack();
            } else {
              this.updatePage(8, nextPatieint)
            }
          } else {
            // 最后一个了，无下一个；由之前的显示第一个改为返回看板页面
            this.goBack();
          }
        } else {
          console.log("无患者");
          this.goBack();
        }
      })
    },
    updateNextAbnormalPatient() {
      console.log("下一患者");
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        pageIndex: this.$route.query.pageIndex,
        pageSize: 10
      };
      this.getAbnormalFollowupListAsync(params).then(res => {
        if (res.retValue.length > 0) {
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index)
          if (nextPatieint) {
            if (this.$route.query.followupPatientId == nextPatieint.followupPatientId) {
              this.goBack();
            } else {
              this.updatePage(3, nextPatieint)
            }
          } else {
            // this.updatePage(3, res.retValue[0])
            // 最后一个了，无下一个；由之前的显示第一个改为返回看板页面
            this.goBack();
          }
        } else {
          console.log("无患者");
          this.goBack();
        }
      });
    },
    updateNextAllAbPatient() {
      console.log("下一患者");
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        pageIndex: this.$route.query.pageIndex,
        pageSize: 10,
        isAll: this.$route.query.isAll
      };
      this.asyncGetPatientInfoList(params).then(res => {
        if (res.retValue.length > 0) {
          this.resetPatient();
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index * 1)
          if (nextPatieint) {
            if (this.$route.query.followupPatientId == nextPatieint.followupPatientId) {
              this.goBack();
            } else {
              this.updatePage(-1, nextPatieint)
            }
          } else {
            // this.updatePage(-1, res.retValue[0])
            // 最后一个了，无下一个；由之前的显示第一个改为返回看板页面
            this.goBack();
          }
        } else {
          console.log("无患者");
          this.goBack();
        }
      });
    },
    updateNextCallLaterPatient() {
      console.log("下一患者");
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        pageIndex: this.$route.query.pageIndex,
        pageSize: 10
      };
      this.getCallLaterFollowupListAsync(params).then(res => {
        console.log('获取下一个', res);
        if (res.retValue.length > 0) {
          this.resetPatient();
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index * 1)
          if (nextPatieint) {
            if (this.$route.query.followupPatientId == nextPatieint.followupPatientId) {
              this.goBack();
            } else {
              this.updatePage(4, nextPatieint)
            }
          } else {
            // this.updatePage(4, res.retValue[0])
            // 最后一个了，无下一个；由之前的显示第一个改为返回看板页面
            this.goBack();
          }
        } else {
          console.log("无患者");
          this.goBack();
        }
      });
    },
    updatePage(num, params) {
      //num: 3异常患者处理  4稍后随访 7收藏夹
      // 异常患者：下一位患者的最后拨打时间是今日时，有提示--确定则返回任务详情页面，点击取消则继续跳转到下一位患者
      if (num == 3) {
        console.log('3异常患者处理', params.followUpDate);
        if (this.compareDate(params.followUpDate)) {
          this.$confirm('下一位异常随访今日已经拨打过，将自动返回到任务详情页', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true
          }).then(() => {
            this.$router.push({
              path: "/taskDetail",
              query: {
                pageIndex: this.$route.query.pageIndex,
                diseaseId: this.$route.query.diseaseId,
                isRemindStudy: this.$route.query.isRemindStudy,
                isSingleDuration: this.$route.query.isSingleDuration,
                isTotalDuration: this.$route.query.isTotalDuration,
                type: this.$route.query.type ? this.$route.query.type : '',
                followupSource: this.$route.query.followupSource || 1
              }
            });
          }).catch(() => {
            this.$router.push({
              path: "/callPatient",
              query: {
                pageIndex: this.$route.query.pageIndex,
                index: params.index,
                abnormal: num,
                followUpPatientInfoId: params.followUpPatientInfoId,
                followupPatientId: params.followupPatientId,
                diseaseId: this.$route.query.diseaseId,
                patientId: params.patientId,
                followupSource: this.$route.query.followupSource || 1,
                isRemindStudy: this.$route.query.isRemindStudy,
                isSingleDuration: this.$route.query.isSingleDuration,
                isTotalDuration: this.$route.query.isTotalDuration,
              }
            });
          });
        } else {
          this.$router.push({
            path: "/callPatient",
            query: {
              pageIndex: this.$route.query.pageIndex,
              index: params.index,
              abnormal: num,
              followUpPatientInfoId: params.followUpPatientInfoId,
              followupPatientId: params.followupPatientId,
              diseaseId: this.$route.query.diseaseId,
              patientId: params.patientId,
              followupSource: this.$route.query.followupSource || 1,
              isRemindStudy: this.$route.query.isRemindStudy,
              isSingleDuration: this.$route.query.isSingleDuration,
              isTotalDuration: this.$route.query.isTotalDuration,
            }
          });
        }
      } else if (num == 7) {
        this.$router.push({
          path: "/callPatient",
          query: {
            abnormal: 7, //收藏夹
            collectSource: params.source,
            followUpPatientInfoId: params.followupPatientInfoId,
            followupPatientId: params.followupPatientId,
            diseaseId: this.$route.query.diseaseId,
            patientId: params.patientId,
            followupSource: 1,
            index: params.index,
            isRemindStudy: this.$route.query.isRemindStudy,
            isSingleDuration: this.$route.query.isSingleDuration,
            isTotalDuration: this.$route.query.isTotalDuration,
            tabIndex: this.$route.query.tabIndex,
            pageIndex: this.$route.query.currentPage,
          }
        });
      } else {
        this.$router.push({
          path: "/callPatient",
          query: {
            pageIndex: this.$route.query.pageIndex,
            isAll: this.$route.query.isAll || null,
            abnormal: num,
            index: params.index,
            followUpPatientInfoId: params.followUpPatientInfoId,
            followupPatientId: params.followupPatientId,
            diseaseId: this.$route.query.diseaseId,
            patientId: params.patientId,
            followupSource: this.$route.query.followupSource || 1,
            isRemindStudy: this.$route.query.isRemindStudy,
            isSingleDuration: this.$route.query.isSingleDuration,
            isTotalDuration: this.$route.query.isTotalDuration,
          }
        });
      }
    },
    // 收藏夹的下一个
    nextExceptionGo() {
      this.$store.dispatch('requestHandler', {
        fn: 'RestAbnormalFollowupFileControllerGetExceptionPatient',
        params: {
          seatId: sessionStorage.getItem('userid'),
          taskId: this.getTaskCenterId,
          fileId: this.$route.query.tabIndex,
          pageIndex: this.$route.query.pageIndex,
          pageSize: 10,
        }
      }).then(res => {
        this.abnormalDialogShow = false
        if (res.retValue.length > 0) {
          this.resetPatient();
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index * 1)
          if (nextPatieint) {
            if (this.$route.query.followupPatientId == nextPatieint.followupPatientId) {
              // 根据收藏夹列表顺序（同一收藏夹），最后一个之后获取的最后一个还是该数据的情况，直接返回
              this.goBack();
            } else {
              this.updatePage(7, nextPatieint)
            }
          } else {
            // this.updatePage(7, res.retValue[0])
            // 最后一个了，无下一个；由之前的显示第一个改为返回看板页面
            this.goBack();
          }
        } else {
          console.log("收藏夹无患者");
          this.goBack();
        }
      })
    },
    goBack() {
      // this.$refs.userRemark.submitResult();
      if (this.$route.query.abnormal == 6) {
        //今日完成-患者
        this.$router.go(-1)
      } else {
        this.$router.replace({
          path: "/taskDetail",
          query: {
            pageIndex: 1,
            isOpen: this.$route.query.isOpen,
            diseaseId: this.$route.query.diseaseId,
            isRemindStudy: this.$route.query.isRemindStudy,
            isSingleDuration: this.$route.query.isSingleDuration,
            isTotalDuration: this.$route.query.isTotalDuration,
            type: this.$route.query.type ? this.$route.query.type : '',
            tabIndex: this.$route.query.tabIndex ? this.$route.query.tabIndex : ""
          }
        });
      }
    },
    // 是否是今日时间
    compareDate(gettime) {
      var year = new Date().getFullYear()
      var month = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1
      var day = new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()
      let today = `${year}-${month}-${day}`
      let date = gettime.split(' ')[0]
      if (today == date) {
        return true;
      } else {
        return false;
      }
    },
    // 是否复核
    isReviewChange() {
      // 管理台是否开启需复核
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupCallCenterServiceGetFollowUpTaskSwitchMark',
            params: {followUpTaskId: this.getTaskCenterId}
          }
      ).then(res => {
        if (res.status == 0) {
          this.isReviewPool = res.retValue.isReviewPool
          if (res.retValue.isReviewPool) {
            if (this.isReview) {
              this.$confirm('是否确认将该患者加入需复核池?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.updateFollowUpPatientInfo()
              }).catch(() => {
                this.isReview = !this.isReview
              });
            } else {
              this.updateFollowUpPatientInfo()
            }
          } else {
            this.updateFollowUpPatientInfo()
          }
        }
      })
    },
    // 修改需复核
    updateFollowUpPatientInfo() {
      let vm = this
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupCallCenterServiceUpdateFollowUpPatientInfoByParams',
            params: {
              followupPatientId: vm.patientData.followupPatientId,
              followUpTaskId: vm.getTaskCenterId,
              isReview: vm.isReview ? (vm.isReviewPool ? 3 : 1) : 0,
              patientId: vm.patientData.patientId,
              userId: sessionStorage.getItem('userid'),
              userName: vm.username,
            }
          }
      ).then(res => {
        if (res.status == 0) {
          // 增加跳转下一个
          if (this.isReviewPool) { //管理台开启需复核
            if (vm.isReview) { //添加到需复核，才跳转到下一个
              if (this.$route.query.abnormal == 7 && this.$route.query.tabIndex) {
                this.nextExceptionGo()
              } else if (this.$route.query.abnormal == 2) {
                this.getPatientData();
                this.getPatientRecord();
                this.getReferenceInfo();
                this.getFollowHistory();
                this.getUserCard();
                this.getTodayFollowupNum()
                this.asyncGetStatis()
              } else {//全部，异常，稍后
                this.abnormalOrAfterGo()
              }
            }
          }

        } else {
          vm.$message.error(res.desc)
          this.isReview = !this.isReview
        }
      })
    },
    // 获取患者标签
    getPatientTags(params) {
      this.patientTags = params
    },
    refreshTags() {
      let vm = this;
      if (vm.$refs['userCard']) {
        vm.$refs['userCard'].getPatientTags()
      }
    },
    // ==================================async 请求====================================
    async isRemindAsync() {
      let request = new RestFeedbackOutControllerIsRemind()
      request.p_followUpPatientInfoId = this.patientData.followUpPatientInfoId
      request.p_followUpTaskId = this.getTaskCenterId
      request.p_isSingleDuration = this.$route.query.isSingleDuration
      request.p_isTotalDuration = this.$route.query.isTotalDuration
      await request.send()
      return request.result
    },
    /**
     * 正常随访任务患者信息
     */
    async asyncGetNormalPatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo();
      info.p_userId = params.userId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else if (info.result.status == -8) {
        // vm.errorHandle(info.result);
        return info.result
      }
    },
    /**
     * 获取随访任务异常患者信息
     */
    async asyncGetAbNormalPatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfo();
      info.p_patientId = params.patientId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      info.p_followupPatientId = params.followupPatientId;
      info.p_followUpPatientInfoId = params.followUpPatientInfoId;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    async getFollowUpPatientConditionAsync(patientId) {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpPatientCondition()
      request.p_followupTaskId = this.getTaskCenterId
      request.p_patientId = patientId
      await request.send()
      return request.result
    },
    /**
     * 获取随访任务未完成的患者信息
     */
    async asyncGetIncompletePatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetIncompleteFollowupTaskPatientInfo();
      info.p_userId = params.userId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    //获取重播患者详情
    async getFollowupTaskReplayPatientInfoAsync(params) {
      let request = new RestNewFollowupCallCenterServiceGetFollowupTaskReplayPatientInfo()
      request.p_followupPatientId = params.followupPatientId
      request.p_userId = params.userId
      request.p_followupTaskId = this.getTaskCenterId
      request.p_followUpPatientInfoId = params.followUpPatientInfoId
      await request.send()
      return request.result
    },
    getPatientInfoByAll(params, type) {
      return new Promise(resolve => {
        if (type == 3) {
          this.asyncGetcallLaterNumberPatientInfo(params)
              .then(res => {
                resolve(res)
              })
        } else if (type == 4 || type == 8) {
          this.asyncGetAbNormalPatientInfo(params)
              .then(res => {
                resolve(res)
              })
        }
      })

    },
    /**
     * 获取随访任务稍后拨打的患者信息
     */
    async asyncGetcallLaterNumberPatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfo();
      // info.p_userId = params.userId;

      info.p_patientId = params.patientId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      info.p_followupPatientId = params.followupPatientId;
      info.p_followUpPatientInfoId = params.followUpPatientInfoId;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    /**
     * 获取今日随访完成的患者详情
     * @constructor
     */
    async asyncGetFollowUpTodayCompletePatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo();
      info.p_followupState = params.followupState;
      info.p_followupTaskId = params.followupTaskId;
      info.p_followupPatientId = params.followupPatientId;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    /**
     * 获取患者联系方式
     * @param patientId
     * @returns {Promise<void>}
     */
    async asyncGetPatientContacks(patientId) {
      let vm = this;
      vm.$refs['userphone'].patientList = []
      let info = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList();
      info.p_patientId = patientId || 124684;
      info.p_followupTaskId = vm.getTaskCenterId
      await info.send()
      if (info.result.status == 0) {
        if (vm.$refs['userphone']) {
          vm.$refs['userphone'].getPatientList(info.result.retValue);
          // vm.manualCallBack(vm.$route.query.callNumber)
          //如果有最近拨打的患者才会调用
          vm.$refs.userphone.checkHasLastCallUser()
              .then(result => {
                // result: true代表没有拨打过
                if (result) {
                  this.hasFinsh = true
                  // if(result == 4) {
                  //     // 重拨
                  //     this.finishStatus = 'successFinsh'
                  // }else {
                  //     this.finishStatus = ''
                  // }
                  // this.finishStatus = ''
                }
                // else {
                //   this.hasFinsh = false
                // }
              })
          if (this.$route.query.followupSource == 2 && !this.hasFinsh) {
            // this.showMask = true   // 重播进入的页面，也要求能直接选择随访情况
            vm.getFollowUpPatientConditionAsync(patientId)
                .then(res1 => {
                  if (res1.retValue.followupState == 16 || res1.retValue.followupState == 17 || res1.retValue.followupState == 18) {
                    this.follow.followStatus = 11
                    this.follow.refuseSecondStatus = res1.retValue.followupState
                  } else {
                    this.follow.followStatus = res1.retValue.followupState
                    this.follow.refuseSecondStatus = ""
                  }

                  this.follow.isDeath = res1.retValue.existenceState ? 2 : (res1.retValue.followupState == 10 ? 3 : 1)
                  this.follow.deathReason = res1.retValue.deathReason
                  let timearr = res1.retValue.deathTime.split('-')
                  this.follow.deathTime = {
                    yearSelect: timearr[0],
                    monthSelect: timearr[1],
                    daySelect: timearr[2]
                  }
                })
          }
        }
      } else {
        vm.errorHandle(info.result);
      }
    },
    async getPatientContacksAsync() {
      let request = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList()
      request.p_patientId = this.$route.query.patientId || this.currentPatientId
      request.p_followupTaskId = this.getTaskCenterId
      await request.send()
      return request.result
    },
    /**
     * 获取随访患者的备注信息
     * @param patientId
     * @returns {Promise<void>}
     */
    async asyncGetPatientRemarks(patientId) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupPatientRemarks();
      info.p_followupPatientId = patientId;
      await info.send()
      if (info.result.status == 0) {
        vm.form.remark = info.result.retValue;
      } else {
        vm.form.remark = ""
      }
    },
    /**
     * 更新随访患者的备注信息
     * @returns {Promise<void>}
     */
    async asyncUpdatePatientRemarks() {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks();
      info.p_followupPatientId = vm.patientData.followupPatientId;
      info.p_followupRemarks = vm.form.remark;

      await info.send();
      vm.saveRemarkIng = false;
      if (info.result.status != 0) {
        vm.$message.error("备注更新失败,请及时联系相关技术（吴明份、吕明涛）")
      }

    },
    /**
     * 更新随访患者信息
     * @return {Promise<void>}
     */
    async asyncUpdatePatientFollowResult(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupPatient();
      for (var keys in params) {
        info['p_' + keys] = params[keys]
      }
      await info.send()
      if (info.result.status == 0) {
        //TODO  更新当前患者的随访信息成功
        vm.judgeStatus(vm.follow.followStatus)
        this.confirmParams = {}
      } else {
        vm.$message.error("处理患者错误:" + info.result.desc)
      }
      vm.finishConfirm = false
      return info.result;
    },
    /**
     * 点击异常患者
     * @return {Promise<void>}
     */
    async asyncUpdateAbnormalPatientFollow() {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupTaskAbnormalCall();
      info.p_userId = this.userid;
      info.p_followUpPatientInfoId = this.patientData.followUpPatientInfoId;
      info.p_taskId = this.getTaskCenterId
      info.p_followupPatientId = vm.patientData.followupPatientId
      await info.send()
      if (info.result.status == 0) {
        vm.judgeStatus(5)
        if (this.$route.query.abnormal == 5) {
          this.$router.go(-1)
        }
      } else {
        vm.$message.error("处理异常患者错误:" + info.result.desc)
      }
      vm.abnormalLoading = false
    },
    //历史抽查记录
    async getFollowupSpotCheckRemarksListAsync(p) {
      let request = new RestReferenceControllerGetFollowupSpotCheckRemarksList();
      request.p_followUpTaskId = p.followupTaskId || null;
      request.p_followUpPatientId = p.followUpPatientId || null;
      await request.send();
      return request.result;
    },
    // 异常随访
    async getAbnormalFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = this.$route.query.pageIndex;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    async asyncGetPatientInfoList(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetAllFollowupTaskPatientInfoList',
        params: {
          userId: p.userId,
          followupTaskId: p.followupTaskId,
          admitNo: p.admitNo,
          patientName: p.patientName,
          followupStatus: p.followupStatus,
          pageIndex: this.$route.query.pageIndex,
          pageSize: 10,
        }
      })
      return result
    },
    // 稍后随访
    async getCallLaterFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = this.$route.query.pageIndex;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    // 更新随访任务异常呼叫或稍后拨打
    async updateAbnormalCallOrCallLaterAsync() {
      let vm = this
      let request = new RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater()
      request.p_userId = vm.userid
          request.p_followUpPatientInfoId = vm.patientData.followUpPatientInfoId
          request.p_laterCallTime = vm.afterCallForm.afterCallTime ? vm.afterCallForm.afterCallTime : null
          request.p_patientId = vm.patientData.patientId
          request.p_followupPatientId = vm.patientData.followupPatientId
          request.p_followupTaskId = vm.getTaskCenterId
      await request.send()
      return request.result
    },
    // 质控开始时间 this.getTaskCenterId
    async addFollowupQualityTimeAsync(fpid) {
      let request = new RestFeedbackOutControllerAddFollowupQualityTime();
      request.p_followupPatientId = fpid;
      request.p_followUpTaskId = this.getTaskCenterId;
      request.p_spotCheckUserId = sessionStorage.getItem('userid');
      await request.send();
      return request.result;
    },
    // // 质控结束时间
    // async updateFollowupQualityTimeAsync() {
    //   let request = new RestFeedbackOutControllerUpdateFollowupQualityTime();
    //   request.p_id = this.followupQualityId;  //质控记录id
    //   console.log('质控结束');
    //   await request.send();
    //   return request.result;
    // },

    async getFollowupPatientReviewAsync() {
      let vm = this
      let request = new RestFeedbackOutControllerGetFollowupPatientReview()
      request.p_followupPatientId = vm.patientData.followupPatientId,
          request.p_followupTaskId = vm.getTaskCenterId,

          await request.send()
      if (request.result.status == 0) {
        this.isReview = (request.result.retValue == 3 || request.result.retValue == 1) ? true : false
      } else {
        this.isReview = false
      }
    },
    async asyncGetStatis() {
      let data = new RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo();
      data.p_userId = this.userid;
      data.p_followupTaskId = this.getTaskCenterId;
      data.p_isFrontPage = false //暂时不会从首页进入
      await data.send();
      if (data.result.status == 0) {
        let _data = data.result.retValue
        console.log('-------------------', _data);
        this.targetData = `${_data.finishQuotaNumber ? _data.finishQuotaNumber : 0}/${_data.distributeQuotaNumber ? _data.distributeQuotaNumber : 0}`
      } else {
        this.targetData = 0 / 0
      }
    },
  },
}
</script>
<style lang="scss">
.qs-content {
  height: calc(100% - 35px) !important
}

* {
  box-sizing: border-box;
}

.dethtime {
  .widget-container {
    width: 60%;
  }
}

.el-main {
  padding-top: 0 !important;
}

.no-data {
  p {
    margin: 40px 0 80px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  display: table-cell;
  height: 60vh;
  vertical-align: middle;
  text-align: center;
  width: 480px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16), 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 15px 15px 15px 20px;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;

}

.patient-page-container {
  padding-left: 443px;
  display: grid;
  grid-template-columns: 400px auto 30%;
  grid-gap: 25px 25px;
  //padding: 20px 20px 0 20px;
  height: calc(100vh - 135px);

  .patient-page-left {
    width: 440px;
    background-color: #fff;
    position: absolute;
    padding: 20px 20px 20px 20px;
    z-index: 8000;
    top: 70px;
    left: 0px;

    .tool-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
    }

    .el-tabs__content {
      height: calc(100vh - 60px - 60px - 360px) !important;
      overflow: auto;
    }

    .checklist-container {
      font-size: 15px;
      border-bottom: 1px solid #ccc;
      padding: 10px 0;
      line-height: 30px;

      .checklist-item-header {
        display: flex;
        justify-content: space-between;
      }

      .item-header-date {
        color: #909399;
      }

      .checklist-item-detail {
        border: 1px solid #ccc;
        padding: 5px;
        border-radius: 4px;
        margin-bottom: 5px;

        p {
          word-break: break-all;
          word-wrap: break-word;
        }

        ul {
          padding: 0 1em;
          list-style-type: disc !important;
          list-style-position: inside !important;
        }

        ol {
          padding: 0 1em;
          list-style-type: decimal !important;
          list-style-position: inside !important;
        }

        em {
          font-style: oblique !important;
        }

        strong {
          font-weight: bold;
        }

        .ql-size-large {
          font-size: 1.5em;
        }

        .ql-size-small {
          font-size: 0.75em;
        }

        .ql-size-huge {
          font-size: 2.5em;
        }
      }

      .picture-show {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .image-view {
          width: 100%;
        }

        .image-view > img {
          width: 40px;
          height: 40px;
          margin-right: 8px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  .mask {
    z-index: 9999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 0;
    left: 0;
  }

  .patient-page-center {
    padding-top: 20px;
    width: 98%;
    margin-right: 20px;
    position: relative;

    .patient-page-center-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.1);
      z-index: 9999;
    }


    .title-panel {
      line-height: 28px;
      padding: 10px 10px;
      text-align: left;
      border-bottom: 1px solid #ccc;
    }

    .followup-status-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .follow-status-title {
      text-align: left;

    }

    .btn-wrapper {
      padding: 8px 10px;
      padding-top: 0px;
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }

    .follow-status-danger {
      width: 100%;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      margin-top: 20px;

      .el-button {
        width: 100%;
        font-weight: 600;
        letter-spacing: 2px;
      }
    }

    .follow-status {
      .follow-status-top {
        position: relative;

        .mask {
          z-index: 99999;
          position: absolute;
          padding: auto;
          top: 69px;
          width: 100%;
          height: calc(100% - 69px);
          background-color: rgba(0, 0, 0, 0.05);
        }
      }

      .label-container {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        padding-bottom: 8px;

        .title-panel-title {
          font-size: 14px;
          font-weight: 700;
          margin-right: 25px;
        }
      }

      .el-radio-group {
        display: flex;
        justify-content: space-around;

        .el-radio {
          min-width: 100px;
          text-align: left;
        }
      }


      .el-textarea {
        width: 380px;
      }

      .hasFinsh {
        .active {
          .el-radio-button__inner {
            font-weight: 600;
          }
        }
      }
    }
  }

  .patient-page-right {
    margin-top: 20px;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    transition: width .1s;
    //height: calc(100% - 60px) !important;
    .qs-header {
      display: flex;
      justify-content: space-between;
      height: 35px;
      align-items: center;
      background-color: #eee;
      padding: 10px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    .stretch {
      font-size: 30px;
    }

    .qs-header-label {
      font-size: 20px;
      color: #000000;
      font-weight: 600;
    }
  }

  .stretchall {
    width: 75%;
    transition: width .3s;
  }

  .label-title {
    line-height: 28px;
    display: inline-block;
    color: #000;
    font-weight: 600;
    font-size: 16px;
  }

}

.patient-page {
  .abnormal-after-dialog {
    .fileId_selected {
      .el-radio {
        margin-right: 25px;
        margin-left: 0px !important;
        margin-bottom: 10px;

        .el-radio__input {
          display: none;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.remark-panel, .follow-status {
  position: relative;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  margin-top: 15px;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 1px;
  position: relative;
}

.remark-panel {
  height: 262px;
  overflow: auto;
  position: relative;

  .remark-box {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
  }
}

.patient-page {
  .abnormal-after-dialog {
    .content {
      display: flex;
      flex-direction: column;
      font-size: 16px;

      .el-form {
        min-height: 200px;
      }

      & > div {
        min-height: 30px;
      }
    }
  }
}
</style>
<style lang="scss">
#incapDialog {
  .el-dialog {
    border-radius: 10px;
    overflow: hidden;
    margin-top: 30vh !important;
  }

  .el-dialog__body {
    padding: 10px !important;
  }

  .el-dialog__header {
    padding: 10px;
    text-align: center;
    font-weight: 700;
    background-color: #f8f8f8;
    border-bottom: 1px solid #ccc;

    span {
      font-size: 16px;
    }
  }
}
</style>
